// extracted by mini-css-extract-plugin
module.exports = {"emptyData":"EmptyData_emptyData__3lpVD"};